module.exports = __webpack_public_path__ + "static/media/rssgray.305445dc.png";